import { useEffect, useState } from "react";
import { env } from "../../constants/env";
import CommonButton from "../../ui/CommonButton";
import classes from "./HowItWorks.module.css";
import axios from "axios";
import { useUser } from "../../context/UserContext";

const list = [
  {
    title: "Step 1: Free Entry",
    desc: "Traders join the two-phase evaluation completely free. No upfront payment is required.",
  },
  {
    title: "Step 2: Challenge set up",
    desc: "All traders start at the same time with identical account sizes and industry-standard rules.",
  },
  {
    title: "Step 3: Pass Threshold",
    desc: "Only 10% of participants per cohort can qualify for funding. Funded accounts are issued on a first-pass, basis. If you’re in profit but slots are full, you get free re-entry next month.",
  },
  {
    title: "Step 4: Activation Fee",
    desc: "Only traders who pass both phases pay a one-time activation fee to claim their funded account.",
  },
];

const HowItWorks = ({ className, setShowPurchase, targetDate }) => {
  const { user } = useUser();

  const calculateTimeLeft = () => {
    const now = new Date();
    const difference = targetDate - now;

    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, totalMs: 0 };
    }

    const days = Math.floor(difference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);

    return { days, hours, minutes, totalMs: difference };
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
  const [slotData, setSlotData] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000 * 60); // update every minute

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const fetchSlotData = async () => {
      try {
        const response = await axios.get(`${env.apiUrl}/api/user/slots`);
        setSlotData(response.data);
      } catch (err) {
        console.error("Failed to fetch slot data:", err);
      }
    };

    fetchSlotData();
  }, []);

  return (
    <>
      <div className={`row mx-0 ${classes.wrapper} ${className}`}>
        <div className={`${classes.payoutPool} col-md-6`}>
          <div className={classes.infoText}>
            <h4>Our Model Explained</h4>
            <p>
              Our model runs on a flywheel: traders enter free challenges,
              generating real-world data that powers proprietary trading
              strategies. These strategies generate returns that fund payouts
              while its performance improves with every cohort.
            </p>
          </div>
          <img src="/images/men-working.svg" />
        </div>
        <div className="col-md-6">
          <ul className={classes.infoList}>
            {list.map((item, i) => (
              <li key={i}>
                <h6>{item.title}</h6> <p>{item.desc}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {setShowPurchase && (
        <div
          className={`${classes.bottomButton} d-flex flex-column align-items-center`}
        >
          {slotData?.availableSlots > 0 &&
            !user?.account?.synced &&
            timeLeft?.totalMs > 0 && (
              <CommonButton
                text={"Enter Free Challenge"}
                className={classes.buttonText}
                onClick={() => setShowPurchase(true)}
              />
            )}
          <p className="mt-3">
            By starting a challenge you agree to our <span>TOS</span>
          </p>
        </div>
      )}
    </>
  );
};

export default HowItWorks;
